import { render } from "./RecipeEditorPage.vue?vue&type=template&id=4510da22&scoped=true&ts=true"
import script from "./RecipeEditorPage.vue?vue&type=script&lang=ts"
export * from "./RecipeEditorPage.vue?vue&type=script&lang=ts"

import "./RecipeEditorPage.vue?vue&type=style&index=0&id=4510da22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4510da22"]])

export default __exports__